export class UpdateDocument {
    constructor(documentRepository) {
      this.documentRepositor = documentRepository;
    }
  
    async execute(UpdateDocRequest) {
      return await this.documentRepositor.UpdateDocument(UpdateDocRequest);
    }
  }